import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import FullscreenModal from "./components/FullScreenModal";
import RegisterKYCModalBody from "./components/RegisterBankKYCModalComponent";
import { RegisterKYCModalFooter } from "./components/ModalFooterKYC";
import useLocationService from "hooks/useLocationService";



import { method } from "lodash";
import { captureAvdm } from "utils/rdService";

function MainAEPSPage() {
  const {
    location,

    permission,
    getLocation,
    checkPermission,
  } = useLocationService(true);
  const navigate = useNavigate();
const [outletLoginModal, setOutletLoginModal] = useState(false);
const [outletLoginBank, setOutletLoginBank] = useState("");
const [outletPidData, setOutletPidData] = useState("");
const [outletLoginLoading, setOutletLoginLoading] = useState(false);
const [outletBankList, setOutletBankList] = useState([]);
  const { name, userid, role } = useSession();
  const [data, setData] = useState(null); // to store API data
  const [loading, setLoading] = useState(true); // to manage loader
  const [error, setError] = useState(null); // to handle errors
  
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [onboardingLoading, setOnboardingLoading] = useState(false);
const [showOtpModal, setShowOtpModal] = useState(false);
const [biometricKycModal, setBiometricKycModal] = useState(false);
const [biometricReferenceKey, setBiometricReferenceKey] = useState("");
const [biometricPidData, setBiometricPidData] = useState("");
const [biometricLoading, setBiometricLoading] = useState(false);
const [otp, setOtp] = useState("");
const [otpError, setOtpError] = useState("");

  const handleFormChange = (data) => setFormData(data);

  const handleStartOnboarding = async () => {
    if (onboardingLoading) return;
    setOnboardingLoading(true);
  
    try {
      await checkPermission();
      const loc = await getLocation(); // { lat, lng }
  
      const payload = new FormData();
      payload.append("userid", userid);
      payload.append("lat", loc?.lat ?? location?.lat);
      payload.append("long", loc?.lng ?? location?.lng);
  
      const res = await fetchWrapper("https://pro.mokshiq.in/merchant_onboarding_3", {
        method: "POST",
        body: payload,
      });
  
      if (res.status) {
        showMainToast("Onboarding completed successfully", "success");
        await handleCheckBiometricKyc();
        return;
      }
  
      // minKYC didn't go through directly — fall back to OTP-based signup
      await handleRequestOtp(loc);
    } catch (err) {
      showMainToast("Something went wrong while starting onboarding", "danger");
    } finally {
      setOnboardingLoading(false);
    }
  };


  const handleRequestOtp = async (loc) => {
    const payload = new FormData();
    payload.append("userid", userid);
    payload.append("lat", loc?.lat ?? location?.lat);
    payload.append("long", loc?.lng ?? location?.lng);
  
    const res = await fetchWrapper("https://pro.mokshiq.in/merchant_onboarding_otp_3", {
      method: "POST",
      body: payload,
    });
  
    if (res.status) {
      showMainToast("OTP sent to your registered mobile number", "success");
      setShowOtpModal(true);
    } else {
      showMainToast(res.data || "Unable to initiate onboarding", "danger");
    }
  };



  const handleVerifyOtp = async () => {
    if (!otp || otp.length < 4) {
      setOtpError("Enter a valid OTP");
      return;
    }
    setOnboardingLoading(true);
  
    try {
      const payload = new FormData();
      payload.append("userid", userid);
      payload.append("lat", location?.lat);
      payload.append("long", location?.lng);
      payload.append("otp", otp);
  
      const res = await fetchWrapper("https://pro.mokshiq.in/merchant_onboarding_verification_3", {
        method: "POST",
        body: payload,
      });
  
      // in handleVerifyOtp, on OTP verify success:
    if (res.status) {
      showMainToast("Onboarding completed successfully", "success");
      setShowOtpModal(false);
      setOtp("");
      await handleCheckBiometricKyc();
    } else {
        setOtpError(res.data || "Invalid OTP, please try again");
      }
    } catch (err) {
      setOtpError("Network error, please try again");
    } finally {
      setOnboardingLoading(false);
    }
  };

  const handleCheckBiometricKyc = async ({ fromActivationPending = false } = {}) => {
    try {
      const res = await fetchWrapper(
        `https://pro.mokshiq.in/biometric_kyc_status?userid=${userid}`,
        { method: "POST" }
      );
  
      if (res.status && res.data?.action === "ACTION-REQUIRED") {
        setBiometricReferenceKey(res.data.referenceKey);
        await checkPermission();
        await getLocation();
        setBiometricKycModal(true);
        return;
      }
  
      if (fromActivationPending) {
        // Biometric already done (or not required) — genuinely a bank-side wait
        showMainToast(
          "Your AePS activation is pending at the bank, please try again later.",
          "danger"
        );
        return;
      }
  
      // Called right after onboarding, nothing pending — continue the chain
      await handleCheckOutletStatus();
    } catch (err) {
      showMainToast("Unable to check biometric KYC status", "danger");
    }
  };
  
  const handleBiometricCapture = async () => {
    const response = await captureAvdm("MANTRA", "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=");
    if (response.success) setBiometricPidData(response.data);
    else showMainToast("Fingerprint capture failed: " + response.error, "danger");
  };
  
  const handleSubmitBiometricKyc = async () => {
    if (!biometricPidData) return showMainToast("Please scan fingerprint first", "danger");
  
    setBiometricLoading(true);
    try {
      const payload = new FormData();
      payload.append("userid", userid);
      payload.append("referenceKey", biometricReferenceKey);
      payload.append("lat", location?.lat);
      payload.append("long", location?.lng);
      payload.append("xml_data", biometricPidData);
  
      const res = await fetchWrapper("https://pro.mokshiq.in/biometric_kyc", {
        method: "POST",
        body: payload,
      });
  
      if (res.status) {
        showMainToast("Biometric KYC completed successfully", "success");
        setBiometricKycModal(false);
        setBiometricPidData("");
        // proceed to bank KYC + outlet login check
        
      } else {
        showMainToast(res.data || "Biometric KYC failed", "danger");
      }
    } catch (err) {
      showMainToast("Network error during biometric KYC", "danger");
    } finally {
      setBiometricLoading(false);
    }
  };
  const handleSubmit = (data) => {
    console.log("Form submitted:", data);
    // TODO: Call your KYC register API here
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper(
        `https://pro.mokshiq.in/get_user_profile?user=${userid}`
      );

      setData(response.data);
    } catch (err) {
      showMainToast(err.message, 'danger');
    } finally {
      setLoading(false); // hide loader
    }
  };
  useEffect(() => {
    getLocation();

    fetchData();
  }, []);


  const closeModalAlways = () => {
    const modalEl = document.getElementById("modalAlwaysFullscreen");
    if (modalEl) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) modalInstance.hide();
    }
  };


  const onboardingPS = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      // formData.append("userid", "3");
      const result = await fetchWrapper(
        `https://pro.mokshiq.in/aeps_onboarding?userid=${userid}`
      );

      if (result.status && result.data.onboard_pending === 0) {
        showMainToast(result.data.message, "success");
      } else if (result.status && result.data.hasOwnProperty("redirecturl") && result.data.redirecturl) {
        window.open(result.data.redirecturl, "_blank", "noopener,noreferrer");
      }

      else {
        setError(result.data.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }

  }

  const handleCheckOutletStatus = async () => {
    try {
      const res = await fetchWrapper(
        `https://pro.mokshiq.in/outlet_login_status?userid=${userid}`,
        { method: "POST" }
      );
  
      if (res.status) {
        navigate("/instant_aeps_new");
        return;
      }
  
      if (
        typeof res.data === "string" &&
        res.data.toLowerCase().includes("activation is pending")
      ) {
        // Usually caused by incomplete biometric KYC — check that before telling user to wait
        await handleCheckBiometricKyc({ fromActivationPending: true });
        return;
      }
  
      await checkPermission();
      await getLocation();
      setOutletLoginModal(true);
    } catch (err) {
      showMainToast("Unable to check outlet login status", "danger");
    }
  };

  useEffect(() => {
  if (!outletLoginModal) return;
  const fetchBanks = async () => {
    try {
      const res = await fetchWrapper("https://pro.mokshiq.in/aeps_bank_list_1");
      if (res?.data) setOutletBankList(res.data);
    } catch (err) {}
  };
  fetchBanks();
}, [outletLoginModal]);

const handleOutletCapture = async () => {
  const response = await captureAvdm("MANTRA", "");
  if (response.success) setOutletPidData(response.data);
  else showMainToast("Fingerprint capture failed: " + response.error, "danger");
};

const handleOutletLogin = async () => {
  if (!outletLoginBank) return showMainToast("Please select a bank", "danger");
  if (!outletPidData) return showMainToast("Please scan fingerprint first", "danger");

  setOutletLoginLoading(true);
  try {
    const payload = new FormData();
    payload.append("user_id", userid);
    payload.append("type", "DAILY_LOGIN");
    payload.append("bankiin", outletLoginBank);
    payload.append("lat", location?.lat);
    payload.append("long", location?.lng);
    payload.append("xml_data", outletPidData);

    const res = await fetchWrapper("https://pro.mokshiq.in/aeps_outlet_login", {
      method: "POST",
      body: payload,
    });

    if (res.status) {
      showMainToast("Outlet login successful", "success");
      setOutletLoginModal(false);
      setOutletPidData("");
      navigate("/instant_aeps_new");
    } else {
      showMainToast(res.data || "Outlet login failed", "danger");
    }
  } catch (err) {
    showMainToast("Network error during outlet login", "danger");
  } finally {
    setOutletLoginLoading(false);
  }
};

  const checkSoftmintKYC = async () => { 
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("platform", "WEB");
      const result = await fetchWrapper(
        `https://pro.mokshiq.in/soft_two_factor_status`,
        {
          method: "POST",
          body: formData
        }
      );

      if (!result.status) {
        showMainToast(result.data, "danger");
        window.open(result.new_data.data);
      } else if (result.status) {
       navigate("/aeps_service_2");
       showMainToast(result.data, "success");
      }

      else {
        setError(result.data.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }
    }
  const updateMaplocation = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("transection_platform", "WEB");
      formData.append("lat", location.lat);
      formData.append("long", location.lng);
      const result = await fetchWrapper(
        `https://pro.mokshiq.in/merchant_location_update`,
        {
          method: "POST",
          body: formData
        }
      );

      if (result.status) {
        showMainToast(result.message, "success");
        fetchData();
      }

      else {
        setError(result.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }

  }

  return (
    <main style={{ backgroundColor: "#f8fafc", minHeight: "100vh", paddingBottom: "40px" }}>
      <div className="container-fluid px-4 py-3">
        {/* Header Hero Banner with Banner Image Graphic */}
        <div
          className="card border-0 mb-4 position-relative overflow-hidden shadow-sm"
          style={{
            background: "linear-gradient(135deg, #f5efff 0%, #eef2ff 60%, #e0e7ff 100%)",
            borderRadius: "20px"
          }}
        >
          <div className="card-body p-3 p-md-4 position-relative z-1">
            <div className="row align-items-center">
              <div className="col-12 col-md-6 col-lg-7">
                <div className="d-flex align-items-center mb-2">
                  <div
                    style={{
                      width: "5px",
                      height: "28px",
                      backgroundColor: "#7e57c2",
                      borderRadius: "4px",
                      marginRight: "12px"
                    }}
                  ></div>
                  <h3 className="fw-extrabold mb-0" style={{ color: "#0f172a", fontSize: "24px", letterSpacing: "-0.5px" }}>
                    AEPS Service
                  </h3>
                </div>
                <ul className="d-flex align-items-center gap-2 list-unstyled mb-0 ms-3" style={{ fontSize: "13.5px" }}>
                  <li>
                    <a className="text-decoration-none d-flex align-items-center gap-1.5" href="#" style={{ color: "#64748b", fontWeight: "500" }}>
                      <i className="ph-duotone ph-house-line" style={{ fontSize: "16px", color: "#7e57c2" }}></i>
                      <span>Services</span>
                    </a>
                  </li>
                  <li style={{ color: "#94a3b8" }}>/</li>
                  <li className="fw-bold" style={{ color: "#7e57c2" }}>
                    AEPS
                  </li>
                </ul>
              </div>

              {/* Right Side AEPS Banner Image Graphic */}
              <div className="col-12 col-md-6 col-lg-5 text-end d-none d-md-block">
                <img
                  src="../assets/images/service/aeps-banner.png"
                  onError={(e) => { e.target.src = "/assets/images/service/aeps-banner.png"; }}
                  alt="AEPS Service Banner"
                  className="img-fluid"
                  style={{
                    maxHeight: "135px",
                    objectFit: "contain",
                    mixBlendMode: "multiply"
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="card border-0 shadow-sm" style={{ borderRadius: "20px" }}>
                <div className="card-body p-5">
                  <div className="loader-container">
                    <div className="loader-main">
                      <div className="loader_box">
                        <div className="loader_16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row g-4">
            {/* Card 1: Quick AEPS */}
            <div className="col-12 col-md-6 col-xl-4">
              <div
                className="card border-0 shadow-sm h-100 position-relative overflow-hidden"
                style={{
                  borderRadius: "24px",
                  backgroundColor: "#ffffff",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease"
                }}
              >
                <div className="card-body p-4 d-flex flex-column justify-content-between">
                  <div>
                    {/* Top Row: Left Icon Avatar + Right Badge */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "16px",
                          backgroundColor: "#f3e8ff",
                          color: "#7e57c2"
                        }}
                      >
                        <i className="ph-duotone ph-file-text" style={{ fontSize: "26px" }}></i>
                      </div>

                      <span
                        className="badge rounded-pill d-inline-flex align-items-center gap-1.5 px-3 py-2"
                        style={{
                          backgroundColor: "#f3e8ff",
                          color: "#6c5ce7",
                          fontWeight: "700",
                          fontSize: "12.5px"
                        }}
                      >
                        <i className="ph-bold ph-lightning" style={{ fontSize: "14px" }}></i>
                        Fast & Secure
                      </span>
                    </div>

                    {/* Middle Row: Title & Subtitle + Graphic Illustration */}
                    <div className="d-flex align-items-start justify-content-between gap-2 my-2">
                      <div>
                        <h4 className="fw-extrabold mb-1" style={{ color: "#0f172a", fontSize: "22px" }}>
                          Quick AEPS
                        </h4>
                        <p className="text-muted mb-0" style={{ fontSize: "13.5px", lineHeight: "1.4" }}>
                          {data?.paeps_onboarding === true && data?.paeps_reg_bank2 === true && data?.paeps_auth_bank2 === true
                            ? data?.gst_num === "123"
                              ? "Update your shop location details."
                              : "Auth Bank KYC already completed ✅"
                            : data?.paeps_onboarding === true && data?.paeps_reg_bank2 === true
                            ? "Please initiate with Auth KYC."
                            : data?.paeps_onboarding === true && data?.paeps_reg_bank2 === false
                            ? "Please initiate onboarding with bank."
                            : "Submit KYC – Aadhaar, PAN, and Bank details."}
                        </p>
                      </div>

                      {/* Aadhaar / Fingerprint Card Watermark Graphic */}
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0 p-2 position-relative"
                        style={{
                          width: "80px",
                          height: "65px",
                          borderRadius: "16px",
                          background: "linear-gradient(135deg, #f5efff 0%, #eef2ff 100%)",
                          border: "1px solid #e9dcfd"
                        }}
                      >
                        <i className="ph-duotone ph-fingerprint" style={{ fontSize: "36px", color: "#7e57c2" }}></i>
                        <div
                          className="position-absolute d-flex align-items-center justify-content-center"
                          style={{
                            bottom: "6px",
                            right: "6px",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            backgroundColor: "#7e57c2",
                            color: "#ffffff"
                          }}
                        >
                          <i className="ph-bold ph-arrow-up" style={{ fontSize: "12px" }}></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Action Button */}
                  <div className="mt-4">
                    {data?.paeps_onboarding === true && data?.paeps_reg_bank2 === true && data?.paeps_auth_bank2 === true ? (
                      data?.gst_num === "123" ? (
                        <button
                          className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                          type="button"
                          onClick={updateMaplocation}
                          style={{
                            height: "50px",
                            borderRadius: "14px",
                            background: "linear-gradient(135deg, #7e57c2 0%, #5b21b6 100%)",
                            border: "none",
                            fontWeight: "700",
                            fontSize: "15px"
                          }}
                        >
                          <span>Update Map Location</span>
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                          >
                            <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                          </div>
                        </button>
                      ) : (
                        <button
                          className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                          type="button"
                          onClick={() => { window.location.href = "/aeps_service" }}
                          style={{
                            height: "50px",
                            borderRadius: "14px",
                            background: "linear-gradient(135deg, #7e57c2 0%, #5b21b6 100%)",
                            border: "none",
                            fontWeight: "700",
                            fontSize: "15px"
                          }}
                        >
                          <span>Start Transaction</span>
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                          >
                            <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                          </div>
                        </button>
                      )
                    ) : data?.paeps_onboarding === true && data?.paeps_reg_bank2 === true ? (
                      <button
                        className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#modalAlwaysFullscreen"
                        style={{
                          height: "50px",
                          borderRadius: "14px",
                          background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          border: "none",
                          fontWeight: "700",
                          fontSize: "15px"
                        }}
                      >
                        <span>Start Auth KYC</span>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                        >
                          <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                        </div>
                      </button>
                    ) : data?.paeps_onboarding === true && data?.paeps_reg_bank2 === false ? (
                      <button
                        className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#modalAlwaysFullscreen"
                        style={{
                          height: "50px",
                          borderRadius: "14px",
                          background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          border: "none",
                          fontWeight: "700",
                          fontSize: "15px"
                        }}
                      >
                        <span>Register Bank KYC</span>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                        >
                          <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                        </div>
                      </button>
                    ) : (
                      <button
                        className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                        type="button"
                        onClick={onboardingPS}
                        style={{
                          height: "50px",
                          borderRadius: "14px",
                          background: "linear-gradient(135deg, #7e57c2 0%, #5b21b6 100%)",
                          border: "none",
                          fontWeight: "700",
                          fontSize: "15px"
                        }}
                      >
                        <span>Start Onboarding</span>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                        >
                          <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Instant AEPS KYC */}
            <div className="col-12 col-md-6 col-xl-4">
              <div
                className="card border-0 shadow-sm h-100 position-relative overflow-hidden"
                style={{
                  borderRadius: "24px",
                  backgroundColor: "#ffffff",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease"
                }}
              >
                <div className="card-body p-4 d-flex flex-column justify-content-between">
                  <div>
                    {/* Top Row: Left Icon Avatar + Right Badge */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "16px",
                          backgroundColor: "#eff6ff",
                          color: "#2563eb"
                        }}
                      >
                        <i className="ph-duotone ph-shield-check" style={{ fontSize: "26px" }}></i>
                      </div>

                      <span
                        className="badge rounded-pill d-inline-flex align-items-center gap-1.5 px-3 py-2"
                        style={{
                          backgroundColor: "#eff6ff",
                          color: "#2563eb",
                          fontWeight: "700",
                          fontSize: "12.5px"
                        }}
                      >
                        <i className="ph-bold ph-clock" style={{ fontSize: "14px" }}></i>
                        Instant Verification
                      </span>
                    </div>

                    {/* Middle Row: Title & Subtitle + Graphic Illustration */}
                    <div className="d-flex align-items-start justify-content-between gap-2 my-2">
                      <div>
                        <h4 className="fw-extrabold mb-1" style={{ color: "#0f172a", fontSize: "22px" }}>
                          {data?.outlet_id !== null && data?.outlet_id !== "" && data?.outlet_id !== undefined
                            ? "Instant AEPS KYC"
                            : "Instant AEPS"}
                        </h4>
                        <p className="text-muted mb-0" style={{ fontSize: "13.5px", lineHeight: "1.4" }}>
                          {data?.outlet_id !== null && data?.outlet_id !== "" && data?.outlet_id !== undefined
                            ? "Check AEPS KYC status instantly."
                            : "Submit KYC – Upload Aadhaar, PAN, and Bank details."}
                        </p>
                      </div>

                      {/* User Verification Card Graphic */}
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0 p-2 position-relative"
                        style={{
                          width: "80px",
                          height: "65px",
                          borderRadius: "16px",
                          background: "linear-gradient(135deg, #eff6ff 0%, #e0e7ff 100%)",
                          border: "1px solid #c7d2fe"
                        }}
                      >
                        <i className="ph-duotone ph-identification-card" style={{ fontSize: "36px", color: "#2563eb" }}></i>
                        <div
                          className="position-absolute d-flex align-items-center justify-content-center"
                          style={{
                            bottom: "6px",
                            right: "6px",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            backgroundColor: "#10b981",
                            color: "#ffffff"
                          }}
                        >
                          <i className="ph-bold ph-check" style={{ fontSize: "12px" }}></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Action Button */}
                  <div className="mt-4">
                    {data?.outlet_id !== null && data?.outlet_id !== "" && data?.outlet_id !== undefined ? (
                      <button
                        className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                        id="click_1"
                        type="button"
                        onClick={handleCheckOutletStatus}
                        style={{
                          height: "50px",
                          borderRadius: "14px",
                          background: "linear-gradient(135deg, #7e57c2 0%, #5b21b6 100%)",
                          border: "none",
                          fontWeight: "700",
                          fontSize: "15px"
                        }}
                      >
                        <span>Check KYC</span>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                        >
                          <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                        </div>
                      </button>
                    ) : (
                      <button
                        className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                        id="click_1"
                        type="button"
                        onClick={handleStartOnboarding}
                        disabled={onboardingLoading}
                        style={{
                          height: "50px",
                          borderRadius: "14px",
                          background: "linear-gradient(135deg, #7e57c2 0%, #5b21b6 100%)",
                          border: "none",
                          fontWeight: "700",
                          fontSize: "15px"
                        }}
                      >
                        <span>{onboardingLoading ? "Processing..." : "Start Onboarding"}</span>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                        >
                          <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                        </div>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: E AEPS */}
            <div className="col-12 col-md-6 col-xl-4">
              <div
                className="card border-0 shadow-sm h-100 position-relative overflow-hidden"
                style={{
                  borderRadius: "24px",
                  backgroundColor: "#ffffff",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease"
                }}
              >
                <div className="card-body p-4 d-flex flex-column justify-content-between">
                  <div>
                    {/* Top Row: Left Icon Avatar + Right Badge */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "16px",
                          backgroundColor: "#fef3c7",
                          color: "#d97706"
                        }}
                      >
                        <i className="ph-duotone ph-bank" style={{ fontSize: "26px" }}></i>
                      </div>

                      <span
                        className="badge rounded-pill d-inline-flex align-items-center gap-1.5 px-3 py-2"
                        style={{
                          backgroundColor: "#f0fdf4",
                          color: "#16a34a",
                          fontWeight: "700",
                          fontSize: "12.5px"
                        }}
                      >
                        <i className="ph-bold ph-check-circle" style={{ fontSize: "14px" }}></i>
                        Safe & Reliable
                      </span>
                    </div>

                    {/* Middle Row: Title & Subtitle + Graphic Illustration */}
                    <div className="d-flex align-items-start justify-content-between gap-2 my-2">
                      <div>
                        <h4 className="fw-extrabold mb-1" style={{ color: "#0f172a", fontSize: "22px" }}>
                          E AEPS
                        </h4>
                        <p className="text-muted mb-0" style={{ fontSize: "13.5px", lineHeight: "1.4" }}>
                          Submit KYC – Upload Aadhaar, PAN, and Bank details.
                        </p>
                      </div>

                      {/* Bank + Cards Graphic Watermark */}
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0 p-2 position-relative"
                        style={{
                          width: "80px",
                          height: "65px",
                          borderRadius: "16px",
                          background: "linear-gradient(135deg, #fef3c7 0%, #fef08a 100%)",
                          border: "1px solid #fde68a"
                        }}
                      >
                        <i className="ph-duotone ph-credit-card" style={{ fontSize: "36px", color: "#d97706" }}></i>
                        <div
                          className="position-absolute d-flex align-items-center justify-content-center"
                          style={{
                            bottom: "6px",
                            right: "6px",
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            backgroundColor: "#f59e0b",
                            color: "#ffffff"
                          }}
                        >
                          <i className="ph-bold ph-arrow-up" style={{ fontSize: "12px" }}></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Action Button */}
                  <div className="mt-4">
                    <button
                      className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
                      id="click_1"
                      type="button"
                      style={{
                        height: "50px",
                        borderRadius: "14px",
                        background: "linear-gradient(135deg, #7e57c2 0%, #5b21b6 100%)",
                        border: "none",
                        fontWeight: "700",
                        fontSize: "15px"
                      }}
                    >
                      <span>Start Onboarding</span>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ width: "26px", height: "26px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.2)" }}
                      >
                        <i className="ph-bold ph-arrow-right" style={{ fontSize: "14px" }}></i>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <FullscreenModal
        id="modalAlwaysFullscreen"
        title="Register KYC"
        BodyComponent={() => (
          <RegisterKYCModalBody onFormChange={handleFormChange} errors={errors} onSuccess={fetchData} />
        )}
        FooterComponent={() => (
          <RegisterKYCModalFooter
            onSubmit={handleSubmit}
            formData={formData}
            onSuccessClose={closeModalAlways}
          />

        )}

        size="lg"
      />
      {outletLoginModal && (
  <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Outlet Login Required</h5>
          <button type="button" className="btn-close" onClick={() => setOutletLoginModal(false)} />
        </div>
        <div className="modal-body">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select mb-3"
            value={outletLoginBank}
            onChange={(e) => setOutletLoginBank(e.target.value)}
          >
            <option value="">Select Bank</option>
            {outletBankList.map((bank) => (
              <option key={bank.id} value={bank.iinno}>
                {bank.bankName}
              </option>
            ))}
          </select>

          <div className="d-flex justify-content-center">
            <button
              onClick={handleOutletCapture}
              className="btn btn-outline-primary p-0"
              style={{ width: "70px", height: "70px" }}
              type="button"
            >
              <img
                src="../assets/images/service/scan.gif"
                alt="Scan"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </button>
          </div>
          {outletPidData && <p className="text-success text-center mt-2 mb-0">Fingerprint captured</p>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setOutletLoginModal(false)}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleOutletLogin} disabled={outletLoginLoading}>
            {outletLoginLoading ? "Logging in..." : "Login Outlet"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </main>
  );

}

export default MainAEPSPage;
